messageBus = {};

(function(){
    function MessageBus( ){
        var self = this;
        self.messageHandlers = {};
		self._queue = [];
    }

    MessageBus.prototype.subscribe = function(type, cb){
        if (this.messageHandlers[type] === undefined){
            this.messageHandlers[type] = [cb];
        }
        else{
            this.messageHandlers[type].push(cb);
        }
    };

    MessageBus.prototype.unsubscribe = function(type, cb){
        if (this.messageHandlers[type] !== undefined){
            var i;
            for (i = this.messageHandlers[type].length -1 ; i >= 0; --i){
             if(this.messageHandlers[type][i] === cb)
                 this.messageHandlers[type].splice(i,1);
            }
        }
    };
	
	MessageBus.prototype.postImmediate = function(type, message){
		if (this.messageHandlers[type] !== undefined) {
			var i;
			for (i = this.messageHandlers[type].length - 1; i >= 0; --i) {
				this.messageHandlers[type][i](message);
			}									
		}
	}

    MessageBus.prototype.post = function(type, message, isTask){
		var selfie = this;
		selfie._queue.push( { type: type, message: message, isTask: isTask } );
		
		function doPost(self){
			var nextEvent = self._queue[0];
			self.postImmediate(nextEvent.type, nextEvent.message);
						
			self._queue.splice(0,1);
			
			if (nextEvent.isTask && (nextEvent.message.referenceCount === 0) && !nextEvent.message.isDead){
				nextEvent.message.isDead = true;
				self._queue.unshift( { type: nextEvent.type+"Dead" , message: nextEvent.message.data } );
				doPost(self);
			}
			else if (!nextEvent.isTask && (self._queue.length > 0)){
				doPost(self);			
			}
			else if (nextEvent.isTask){
				nextEvent.message.deadCB = function(){
					selfie._queue.unshift( { type: nextEvent.type+"Dead" , message: nextEvent.message.data } );
					doPost(selfie);
				}
			}
		}
		if (selfie._queue.length === 1){
			doPost(selfie);
		}
    };

    MessageBus.prototype.task = function(type, data){
        var task = new Task(type, data);
        this.post(task.name,task, true);
    };
	
	 MessageBus.prototype.taskImmediate = function(type, data){
        var task = new Task(type, data);
		let self = this;
		task.deadCB = function(){
			self.postImmediate(type+"Dead", task.data);
		}
		this.postImmediate(type, task);      

        // did nothinig join?
        if ((task.referenceCount  === 0) && !task.isDead){
            task.sendDead();
        }
    };


    messageBus = new MessageBus();

})();

